import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ResellerDetails } from "../../resellers.types";
import { requestGetResellerById } from "./getResellerById.request";

const useGetResellerById = (
  resellerId: string,
  options?: QueryOptions<ResellerDetails, ApiServiceError<ApiError>>
) => {
  const { data: reseller, ...rest } = useQuery({
    queryKey: ["reseller", resellerId],
    queryFn: async () => {
      return await requestGetResellerById(resellerId);
    },
    enabled: !!resellerId,
    cacheTime: 0,
    ...options
  });

  return { reseller, ...rest };
};

export default useGetResellerById;
